var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"faq-item",class:{'is-expanded': _vm.is.expanded}},[_c('div',{staticClass:"faq-item-question",on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.question))]),_c('div',{staticClass:"faq-item-answer"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }